import script from "./PlaneViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaneViewer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__